/**
 * Contact Us Module Shared Configuration
 * Defines API endpoints, status mappings, table configurations, and formatting utilities.
 */

export const MODULE_CONFIG = {
  name: "Contact Us",
  title: "Contact Us Inquiries",
  subtitle: "Manage tenant customer inquiries, view message dossiers, update status, and send replies.",
  singular: "Inquiry",
  plural: "Inquiries",
  routeBase: "/contact-us",

  // API Endpoints
  endpoints: {
    listing: "contactUs/listing",
    detail: "contactUs/detail",
    statusChange: "contactUs/status/change",
    reply: "contactUs/reply",
    delete: "contactUs/delete",
  },

  // Status Filter Options
  statusOptions: [
    { label: "All Inquiries", value: "all" },
    { label: "Unread", value: "unread" },
    { label: "Read", value: "read" },
    { label: "Replied", value: "replied" },
  ],

  // Status Badges & Color Semantics (High contrast, no light grey)
  statusMap: {
    unread: {
      label: "Unread",
      bgClass: "bg-amber-100 text-amber-900 border-amber-300",
      dotClass: "bg-amber-600",
    },
    read: {
      label: "Read",
      bgClass: "bg-emerald-100 text-emerald-900 border-emerald-300",
      dotClass: "bg-emerald-600",
    },
    replied: {
      label: "Replied",
      bgClass: "bg-blue-100 text-[#115B9D] border-blue-300",
      dotClass: "bg-[#115B9D]",
    },
  },
};

import {
  capitalize,
  capitalizeSentence,
  formatDate,
  formatTime,
  getInitials,
} from "../../methods/methods";

export {
  capitalize,
  capitalizeSentence,
  formatDate,
  formatTime,
  getInitials,
};

